module.exports = __webpack_public_path__ + "media/open_god_chest.b16ffce1.mp4";